interface JobShiftScheduleAttributes {
  rotation?: Array<{ type: string; duration: number }>;
  daysOfWeek?: string[];
  minimumRequiredDaysPerWeek?: number;
  workdaysRequired?: string;
  notes?: string;
}

const WEEKDAYS = new Set(["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY"]);
const WEEKENDS = new Set(["SATURDAY", "SUNDAY"]);

export function computeScheduleType(
  jobShift: JobShiftScheduleAttributes
): "4_on_2_off" | "flexible" | "fixed" | "other" | undefined {
  if (
    jobShift.rotation?.length === 2 &&
    jobShift.rotation[0]?.type === "on" &&
    jobShift.rotation[0]?.duration === 4 &&
    jobShift.rotation[1]?.type === "off" &&
    jobShift.rotation[1]?.duration === 2
  ) {
    return "4_on_2_off";
  }

  if (
    (!jobShift.rotation || jobShift.rotation.length === 0) &&
    jobShift.minimumRequiredDaysPerWeek !== undefined
  ) {
    return "flexible";
  }

  if (
    (!jobShift.rotation || jobShift.rotation.length === 0) &&
    jobShift.daysOfWeek &&
    jobShift.daysOfWeek.length > 0 &&
    jobShift.minimumRequiredDaysPerWeek === undefined
  ) {
    return "fixed";
  }

  if (
    (!jobShift.rotation || jobShift.rotation.length === 0) &&
    (!jobShift.daysOfWeek || jobShift.daysOfWeek.length === 0) &&
    jobShift.notes
  ) {
    return "other";
  }

  return undefined;
}

export function computeWorkdaysRequired(
  daysOfWeek: string[] | undefined
): "weekdays" | "weekends" | "both" | undefined {
  if (!daysOfWeek || daysOfWeek.length === 0) {
    return undefined;
  }

  const hasWeekdays = daysOfWeek.some((day) => WEEKDAYS.has(day.toUpperCase()));
  const hasWeekends = daysOfWeek.some((day) => WEEKENDS.has(day.toUpperCase()));

  if (hasWeekdays && hasWeekends) {
    return "both";
  }

  if (hasWeekdays) {
    return "weekdays";
  }

  if (hasWeekends) {
    return "weekends";
  }

  return undefined;
}
